import React from 'react'
import PropTypes from 'prop-types'
import styles from './textInput.css'

export default class TextInput extends React.Component {
  constructor (props) {
    super(props)
    const { text } = props

    this.state = {
      text
    }
  }

  componentWillMount () {
    const { text } = this.state
    this.setState({ value: text })
  }

  handleChange ({ target: { value } }) {
    const { maxLength, onChange } = this.props
    if (value.length > maxLength) {
      return
    }

    this.setState({ value }, () => {
      onChange(value)
    })
  }

  render () {
    const { hint, inputRef } = this.props
    const hintStyles = [styles.hint, styles[hint.type]]

    return (
      <div className={styles.wrapper}>
        <input
          type='text'
          value={this.state.value}
          className={styles.input}
          onChange={this.handleChange.bind(this)}
          ref={inputRef}
        />
        <span className={hintStyles.join(' ')}>{hint.text}</span>
      </div>
    )
  }
}

TextInput.propTypes = {
  hint: PropTypes.object,
  inputRef: PropTypes.func,
  maxLength: PropTypes.number,
  text: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

TextInput.defaultProps = {
  hint: { type: 'info', text: '' },
  text: ''
}



// WEBPACK FOOTER //
// ./src/components/inputs/textInput.jsx